var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFolder = function SvgFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "45px",
    viewBox: "0 0 60 45",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Path")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Welcome",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Details-Copy",
    transform: "translate(-933.000000, -388.000000)",
    fill: "#F99A01",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987.375,395.5 L964.875,395.5 L958.710593,389.335593 C957.855427,388.480427 956.695573,388 955.486186,388 L938.625,388 C935.518359,388 933,390.518359 933,393.625 L933,427.375 C933,430.481641 935.518359,433 938.625,433 L987.375,433 C990.481641,433 993,430.481641 993,427.375 L993,401.125 C993,398.018359 990.481641,395.5 987.375,395.5 Z",
    id: "Path"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder.ee9dd6c8.svg";
export { ForwardRef as ReactComponent };